import { Icon } from "@sagot/ui";

/** A quiet text link beside the QR code; a full-width button on a phone, where the same device cannot scan its own screen. */
const LINK_CLASS =
  "inline-flex items-center gap-1.5 text-xs font-semibold text-primary-ink hover:underline " +
  "max-sm:h-11 max-sm:w-full max-sm:justify-center max-sm:rounded-md max-sm:bg-primary max-sm:px-4 max-sm:text-sm max-sm:text-on-primary max-sm:hover:bg-primary-hover max-sm:hover:no-underline";

/** `otpauth://` link that adds the account straight to an authenticator app on this device. */
export function OpenAuthenticatorLink({ uri, label }: { uri: string; label: string }) {
  return (
    <a href={uri} className={LINK_CLASS}>
      <Icon name="smartphone" className="size-3.5 max-sm:size-4" />
      {label}
    </a>
  );
}
